import React from "react";
import { useNavigate } from "react-router-dom";
import { Lightbulb, GraduationCap, Video, MapPin } from "lucide-react";
import PageLayout from "../components/PageLayout";
import MenuButton from "../components/MenuButton";
import { useLang } from "../context/LangContext";

const LearnHubPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  const items = [
    {
      icon: Lightbulb,
      title: t("catKnowledge"),
      subtitle: t("catKnowledgeSub"),
      path: "/knowledge",
    },
    {
      icon: GraduationCap,
      title: t("catShpargalka"),
      subtitle: t("catShpargalkaSub"),
      path: "/shpargalka",
    },
    {
      icon: Video,
      title: t("catVideos"),
      subtitle: t("catVideosSub"),
      path: "/videos",
    },
    {
      icon: MapPin,
      title: t("catSchools"),
      subtitle: t("catSchoolsSub"),
      path: "yandex-link",
    },
  ];

  const handleClick = (path: string) => {
    if (path === "yandex-link") {
      window.open(
        "https://yandex.uz/maps/10335/tashkent/category/driving_school/184105264/",
        "_blank",
        "noopener,noreferrer",
      );
      return;
    }
    navigate(path);
  };

  return (
    <PageLayout title="O'rganish">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((item, i) => (
          <MenuButton
            key={i}
            icon={item.icon}
            title={item.title}
            subtitle={item.subtitle}
            onClick={() => handleClick(item.path)}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default LearnHubPage;
